import { render, staticRenderFns } from "./doodle-card.vue?vue&type=template&id=6143ea07&lang=pug&"
import script from "./doodle-card.vue?vue&type=script&lang=js&"
export * from "./doodle-card.vue?vue&type=script&lang=js&"
import style0 from "./doodle-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports